function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import TunnelVisionHeader from "./TunnelVisionHeader";
import PropTypes from 'prop-types';
import * as React from 'react';
import { StyleSheet, css, spacing, zIndex, color, breakPoint, fontFamily } from "../../../styles/theme";
var ESCAPE_KEY_CODE = 27;
var TAB_KEY = 9;
var LEVEL_1_PADDING = 24; // px
var LEVEL_2_PADDING = 2 * LEVEL_1_PADDING;
var WINDOW_OFFSET = 100; // %
var SLIDE_DURATION = 400; // milliseconds
var SLIDE_DIRECTION = {
  IN: -1,
  OUT: 1
};
var BORDER_WIDTH = 1;
var HEADER_HEIGHT = 72;
var TOTAL_HEADER_HEIGHT = HEADER_HEIGHT + BORDER_WIDTH;
var FOOTER_HEIGHT = 60;
var TOTAL_FOOTER_HEIGHT = FOOTER_HEIGHT + BORDER_WIDTH;
var CONFIG = {
  keyFrameSlideIn: {
    '0%': {
      transform: "translateX(".concat(WINDOW_OFFSET, "%)")
    },
    '100%': {
      transform: 'translateX(0)'
    }
  },
  keyFrameSlideOut: {
    '0%': {
      transform: 'translateX(0)'
    },
    '100%': {
      transform: "translateX(".concat(WINDOW_OFFSET, "%)")
    }
  }
};
var styles = StyleSheet.create({
  TunnelVision: {
    //
  },
  tunnelVisionContentContainer: _defineProperty({
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    height: "calc(100% - ".concat(TOTAL_HEADER_HEIGHT, "px)"),
    maxHeight: "calc(100% - ".concat(TOTAL_HEADER_HEIGHT, "px)"),
    alignItems: 'stretch'
  }, "@media (max-width: ".concat(breakPoint.md, "px)"), {
    flexDirection: 'column'
  }),
  tunnelVisionFooterContainer: {
    height: "".concat(FOOTER_HEIGHT, "px"),
    borderTop: "1px solid ".concat(color.border),
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontFamily: fontFamily.body,
    margin: 0
  },
  tunnelVisionContentContainerWithFooter: {
    height: "calc(100% - ".concat(TOTAL_HEADER_HEIGHT, "px - ").concat(TOTAL_FOOTER_HEIGHT, "px)"),
    maxHeight: "calc(100% - ".concat(TOTAL_HEADER_HEIGHT, "px - ").concat(TOTAL_FOOTER_HEIGHT, "px)")
  },
  tunnelVisionOverlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    height: '100%',
    width: '100%',
    backgroundColor: color.gray,
    opacity: 0.5,
    zIndex: zIndex.lg,
    cursor: 'pointer'
  },
  tunnelVisionWindow: _defineProperty({
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    transform: 'translateZ(0)',
    bottom: 0,
    maxWidth: '100%',
    maxHeight: '100%',
    zIndex: zIndex.lg,
    backgroundColor: color.white,
    boxShadow: '0 0 3em 1em var(--cds-color-darken-200, rgba(0,0,0,0.2))'
  }, "@media (max-width: ".concat(breakPoint.md, "px)"), {
    left: 0,
    marginLeft: spacing.md,
    transform: 'none'
  }),
  tunnelVisionWindowLevel1: {
    width: "calc(100% - ".concat(LEVEL_1_PADDING, "px)"),
    left: "".concat(LEVEL_1_PADDING, "px"),
    maxWidth: "calc(100% - ".concat(LEVEL_1_PADDING, "px)")
  },
  tunnelVisionWindowLevel2: {
    width: "calc(100% - ".concat(LEVEL_2_PADDING, "px)"),
    left: "".concat(LEVEL_2_PADDING, "px"),
    maxWidth: "calc(100% - ".concat(LEVEL_2_PADDING, "px)")
  },
  windowSlideIn: {
    animationName: [CONFIG.keyFrameSlideIn],
    animationDuration: "".concat(SLIDE_DURATION, "ms"),
    animationTimingFunction: 'ease'
  },
  windowSlideOut: {
    animationName: [CONFIG.keyFrameSlideOut],
    animationDuration: "".concat(SLIDE_DURATION, "ms"),
    animationTimingFunction: 'ease'
  }
});
var TunnelVision = /*#__PURE__*/function (_React$Component) {
  function TunnelVision() {
    var _this;
    _classCallCheck(this, TunnelVision);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TunnelVision, [].concat(args));
    _defineProperty(_this, "defaultProps", void 0);
    _defineProperty(_this, "props", void 0);
    _defineProperty(_this, "state", {
      slideDirection: SLIDE_DIRECTION.IN,
      firstTabStop: null,
      lastTabStop: null
    });
    _defineProperty(_this, "handleClose", function () {
      var _this$props = _this.props,
        lastActiveElement = _this$props.lastActiveElement,
        animateOnClose = _this$props.animateOnClose,
        animated = _this$props.animated;
      var shouldAnimateClose = typeof animateOnClose !== 'undefined' ? animateOnClose : animated;
      if (shouldAnimateClose) {
        // wait for slide out animation before closing
        _this.setState({
          slideDirection: SLIDE_DIRECTION.OUT
        });
        setTimeout(_this.props.onClose, SLIDE_DURATION);
      } else {
        _this.props.onClose();
      }
      if (lastActiveElement && lastActiveElement.length) {
        var el = document.querySelector(".".concat(lastActiveElement));
        el && el.focus();
      }
    });
    _defineProperty(_this, "handleKeyPress", function (e) {
      var _this$state = _this.state,
        firstTabStop = _this$state.firstTabStop,
        lastTabStop = _this$state.lastTabStop;
      if (e.keyCode === TAB_KEY) {
        // SHIFT + TAB
        if (e.shiftKey) {
          if (document.activeElement === firstTabStop) {
            e.preventDefault();
            lastTabStop && lastTabStop.focus();
          }
        } else {
          // TAB
          if (document.activeElement === lastTabStop) {
            e.preventDefault();
            firstTabStop && firstTabStop.focus();
          }
        }
      }
      if (e.keyCode === ESCAPE_KEY_CODE) {
        _this.handleClose();
      }
    });
    _defineProperty(_this, "shouldClose", function () {
      var shouldClose = typeof _this.props.shouldAllowClose === 'function' ? _this.props.shouldAllowClose(_this.handleClose) : true;
      if (shouldClose) {
        _this.handleClose();
      }
    });
    return _this;
  }
  _inherits(TunnelVision, _React$Component);
  return _createClass(TunnelVision, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        animateOnOpen = _this$props2.animateOnOpen,
        animated = _this$props2.animated,
        disableKeyPress = _this$props2.disableKeyPress;
      var tunnelVision = document.querySelector('.rc-TunnelVision');
      var shouldAnimateOpen = typeof animateOnOpen !== 'undefined' ? animateOnOpen : animated;
      if (document.body) {
        document.body.style.overflow = 'hidden';
      }
      if (shouldAnimateOpen) {
        // slide in on render
        this.setState({
          slideDirection: SLIDE_DIRECTION.IN
        });
      }
      if (tunnelVision) {
        // find all focusable children
        var focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';
        var focusableElements = tunnelVision.querySelectorAll(focusableElementsString);
        focusableElements = Array.from(focusableElements);
        var firstTabStop = focusableElements[0];
        var lastTabStop = focusableElements[focusableElements.length - 1];
        this.setState({
          firstTabStop: firstTabStop,
          lastTabStop: lastTabStop
        });

        // move focus to first forcasable element in tunnel view after tunnelvision slide in is complete
        setTimeout(function () {
          return firstTabStop.focus();
        }, SLIDE_DURATION);
        if (!disableKeyPress) {
          // $FlowFixMe
          document.addEventListener('keydown', this.handleKeyPress);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (document.body) {
        document.body.style.overflow = '';
      }
      if (!this.props.disableKeyPress) {
        // $FlowFixMe
        document.removeEventListener('keydown', this.handleKeyPress);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        closeElement = _this$props3.closeElement,
        headerElement = _this$props3.headerElement,
        footerElement = _this$props3.footerElement,
        children = _this$props3.children,
        level = _this$props3.level,
        showCloseTooltip = _this$props3.showCloseTooltip,
        animated = _this$props3.animated,
        animateOnOpen = _this$props3.animateOnOpen,
        animateOnClose = _this$props3.animateOnClose,
        contentKey = _this$props3.contentKey,
        backbuttonAriaLabel = _this$props3.backbuttonAriaLabel,
        ariaLabel = _this$props3.ariaLabel,
        closeButtonAlignment = _this$props3.closeButtonAlignment,
        isModal = _this$props3.isModal;
      var slideDirection = this.state.slideDirection;
      var IN = SLIDE_DIRECTION.IN,
        OUT = SLIDE_DIRECTION.OUT;
      var tunnelVisionContentContainerClassName = css(styles.tunnelVisionContentContainer, footerElement && styles.tunnelVisionContentContainerWithFooter);
      var shouldAnimateOpen = typeof animateOnOpen !== 'undefined' ? animateOnOpen : animated;
      var shouldAnimateClose = typeof animateOnClose !== 'undefined' ? animateOnClose : animated;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "rc-TunnelVision ".concat(css(styles.TunnelVision).className)
      }, isModal && {
        'role': 'dialog',
        'aria-modal': 'true',
        'aria-label': ariaLabel
      }), /*#__PURE__*/React.createElement("div", css(styles.tunnelVisionOverlay)), /*#__PURE__*/React.createElement("div", _extends({}, css(styles.tunnelVisionWindow, level === 1 && styles.tunnelVisionWindowLevel1, level === 2 && styles.tunnelVisionWindowLevel2, shouldAnimateOpen && slideDirection === IN && styles.windowSlideIn, shouldAnimateClose && slideDirection === OUT && styles.windowSlideOut), {
        "data-classname": 'tunnelvision-window-' + this.props.level
      }), /*#__PURE__*/React.createElement(TunnelVisionHeader, {
        closeElement: closeElement,
        headerElement: headerElement,
        handleClose: this.shouldClose,
        showCloseTooltip: showCloseTooltip,
        backbuttonAriaLabel: backbuttonAriaLabel,
        closeButtonAlignment: closeButtonAlignment
      }), /*#__PURE__*/React.createElement("div", _extends({}, contentKey ? {
        key: contentKey
      } : {}, tunnelVisionContentContainerClassName), children), footerElement && /*#__PURE__*/React.createElement("div", css(styles.tunnelVisionFooterContainer), footerElement)));
    }
  }]);
}(React.Component);
_defineProperty(TunnelVision, "propTypes", {
  children: PropTypes.node,
  disableKeyPress: PropTypes.bool,
  animated: PropTypes.bool,
  animateOnOpen: PropTypes.bool,
  animateOnClose: PropTypes.bool,
  onClose: PropTypes.func,
  /*
    "shouldAllowClose" is a function that will return a boolean to signal whether the user's closeClick should continue closing the panel or not.
    TunnelVision will also pass its "handleClose" method to "shouldAllowClose" so that "shouldAllowClose" can store the close action for later execution,
    (eg. execute "handleClose" after a user confirms they want to close the panel via a modal).
  */
  shouldAllowClose: PropTypes.func,
  /*
    "closeElement" allows the user to replace the default Tunnel Vision close button with an alternate element.  The "closeElement" will be passed
    down through TunnelVisionHeader to TunnelVisionClose for use instead of the default TunnelVisionClose icon.  Along with static class names, this
    will allow customization of TunnelVision to different layouts without creating multiple component variants that replicate the same behavior but
    implement different presentation.
  */
  closeElement: PropTypes.element,
  headerElement: PropTypes.element,
  footerElement: PropTypes.element,
  // level determines nesting of one TV inside another, used to control container styling
  level: PropTypes.number,
  showCloseTooltip: PropTypes.bool,
  closeButtonAlignment: PropTypes.oneOf(['left', 'right']),
  /*
     In assessments, TunnelVision is wrapped in React Modal to make use of some important features, e.g. react portals. However, this causes an
     unexpected behaviour for screen reader users, because React Modal also renders the 'role="dialog"' and 'aria-modal="true"' attributes.
     If "isModal" is false, these attributes will not be added to TunnelVision. The 'aria-label' attribute will also be omitted, and
     should be added to the parent React Modal.
  */
  isModal: PropTypes.bool
});
_defineProperty(TunnelVision, "defaultProps", {
  disableKeyPress: false,
  animated: true,
  onClose: function onClose() {},
  level: 0,
  showCloseTooltip: false,
  lastActiveElement: '',
  ariaLabel: 'tunnel vision',
  closeButtonAlignment: 'left',
  isModal: true
});
export default TunnelVision;